import React, { useState, useEffect } from 'react';
import { useNavigate,Link } from 'react-router-dom';

import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';


const Register = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [role, setRole] = useState('1'); // Default role is HR
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [referralCode, setReferralCode] = useState('');

  // Extract referral code from URL on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      setReferralCode(ref);
      console.log('Referral code found:', ref);
    }
  }, []);

  const onSubmit = (data) => {
    setIsLoading(true);
    
    const payload = {
        RoleID:role,
        UserName: data.username,
        Email: data.email,
        PhoneNumber: data.phoneNumber,
        Location: data.location,
        Password: data.password,
        confirmPassword: data.confirmPassword,
        referralCode: referralCode, // Include referral code if present
    };
    console.log(payload)

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/register`, payload)
      .then(response => {
        //navigate("/Dashboard")
        setIsLoading(false);
        if (response.data.message === 'Email is already registered') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Email is already registered',
            showConfirmButton: false,
            timer: 3000
          });
        } else if (response.data.message === 'User registered successfully!') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registration successful! Check your email.',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {
            navigate('/Login'); // Redirect after the popup closes
          });
        }
      })
      .catch(error => {
        setIsLoading(false);
        console.error('Error logging in:', error);
      });
  };

  return (
    <>

      <section className="vh-100">
        {isLoading ? <div className="spinner"></div> :
          <>
 <div className="container h-custom">
  <div className="row d-flex justify-content-center align-items-center mt-4">
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
        className="img-fluid"
        alt="Sample" />
    </div>
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <div className="card shadow-lg p-5" style={{ border: 'none' }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {referralCode && (
            <div className="alert alert-info mb-3" role="alert">
              <i className="fas fa-gift me-2"></i>
              <strong>Referral Code Detected!</strong> You're signing up with referral code: <code>{referralCode}</code>
            </div>
          )}
          <label className="form-label text-center">Role</label>
          <div className="d-flex flex-direction-row justify-content-center align-items-center form-outline mb-4">
            <div className="radio-container"  style={{marginRight:30}}>
              <input
                type="radio"
                id="hrRole"
                name="role"
                value="0001"
                style={{
                  transform: 'scale(1.25)',  // Increases the size of the radio button itself
                  marginRight: '10px',  // Optional: Adds some space between the radio button and the label
                }}
                checked={role === '1'}
                onChange={() => setRole('1')} />
              <p htmlFor="hrRole">Personal Branding</p>
            </div>
            <div className="radio-container"  style={{marginRight:30}}>
              <input
                type="radio"
                id="hrRole"
                name="role"
                style={{
                  transform: 'scale(1.25)',  // Increases the size of the radio button itself
                  marginRight: '10px',  // Optional: Adds some space between the radio button and the label
                }}
                value="0004"
                checked={role === '4'}
                onChange={() => setRole('4')} />
              <p htmlFor="hrRole">Business Branding</p>
            </div>
         
            <div className="radio-container">
              <input
                type="radio"
                id="accountantRole"
                name="role"
                style={{
                  transform: 'scale(1.25)',  // Increases the size of the radio button itself
                  marginRight: '10px',  // Optional: Adds some space between the radio button and the label
                }}
                value="0002"
                checked={role === '2'}
                onChange={() => setRole('2')} />
              <p htmlFor="accountantRole">Agency</p>
            </div>
          </div>
          <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
             {role==1 ?"Username" :"Company Name"} 
            </label>
            <input
              type="text"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.username ? 'is-invalid' : ''}`}
              placeholder= {role==1 ?"Username" :"Company Name"} 
              {...register('username', { 
                required:  role==1 ?"Username is required" :"Company Name is required",
              })}
            />
            {errors.username && <div className="invalid-feedback">{errors.username.message}</div>}
          </div>
          {role==2 &&
            <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
              Location
            </label>
            <input
              type="text"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.location ? 'is-invalid' : ''}`}
              placeholder="Enter Location"
              {...register('location', { 
                required: 'Location is required', 
               
              })}
            />
            {errors.location && <div className="invalid-feedback">{errors.location.message}</div>}
          </div>}
          {role==2 &&
            <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
              Mobile Number
            </label>
            <input
              type="text"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.phoneNumber ? 'is-invalid' : ''}`}
              placeholder="Enter Mobile Number"
              {...register('phoneNumber', { 
                required: 'Mobile Number is required', 
               
              })}
            />
            {errors.phoneNumber && <div className="invalid-feedback">{errors.phoneNumber.message}</div>}
          </div>}
          
          <div className="form-outline mb-4">
            <label className="form-label" htmlFor="form3Example3">
              Email address
            </label>
            <input
              type="email"
              id="form3Example3"
              className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
              placeholder="Enter a valid email address"
              {...register('email', { 
                required: 'Email is required', 
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: 'Invalid email address'
                }
              })}
            />
            {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
          </div>

          <div className="form-outline mb-3">
  <label className="form-label fw-bold" htmlFor="form3Example4">Password</label>

  <div className="input-group">
    <input
      type={showPassword ? 'text' : 'password'}
      id="form3Example4"
      className={`form-control form-control-lg border-end-0 ${errors.password ? 'is-invalid' : ''}`}
      placeholder="Enter password"
      {...register('password', { required: 'Password is required' })}
    />
    
    <span
      className="input-group-text border-start-0"
      style={{ cursor: 'pointer', backgroundColor: 'transparent' }}
      onClick={() => setShowPassword(prev => !prev)}
    >
      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
    </span>

  </div>
  {errors.password && (
    <div className="invalid-feedback d-block">{errors.password.message}</div>
  )}

</div>


<div className="form-outline mb-3">
  <label className="form-label fw-bold" htmlFor="form3Example5">Confirm Password</label>

  <div className="input-group">
    <input
      type={showConfirmPassword ? 'text' : 'password'}
      id="form3Example5"
      className={`form-control form-control-lg border-end-0 ${errors.confirmPassword ? 'is-invalid' : ''}`}
      placeholder="Enter Confirm Password"
      {...register('confirmPassword', { 
        required: 'Confirm Password is required',
      })}
    />

<span
      className="input-group-text border-start-0"
      style={{ cursor: 'pointer', backgroundColor: 'transparent' }}
      onClick={() => setShowConfirmPassword(prev => !prev)}
    >
      <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
    </span>
    {errors.confirmPassword && (
    <div className="invalid-feedback  d-block">{errors.confirmPassword.message}</div>
  )}
  </div>

  
</div>


          
          <div className="form-check mt-3 mb-3">
  <input
    type="checkbox"
    id="consentCheckbox"
    className={`form-check-input ${errors.consent ? 'is-invalid' : ''}`}
    {...register('consent', { required: 'You must accept the terms and conditions' })}
  />
  <label className="form-check-label" htmlFor="consentCheckbox" style={{ fontSize: '10px' }}>
    By posting or scheduling content through this platform, I confirm that I am the rightful owner or have the necessary rights to share the content, and I grant my full consent for this platform to use, store, and publish my posts on my behalf across connected networks.
  </label>
  {errors.consent && <div className="invalid-feedback d-block">{errors.consent.message}</div>}
</div>

          <div className="text-center  d-flex justify-content-between text-lg-start mt-4 pt-2">
           
           <button
             type="submit"
             className="btn btn-primary"
             disabled={isSubmitting}
             style={{ backgroundColor: '#2e3192',borderRadius:8 }}
           >
             Register
           </button>
           <Link to='/Login'>
           {/* <button
             type="submit"
             className="btn btn-primary"
            //  disabled={isSubmitting}
            style={{backgroundColor: '#2e3192',borderRadius:8 }}>Login</button> */}
                        <p  style={{color:'#000',marginTop:20}}><b>Login?</b></p>

           </Link>
         </div>
        </form>
      </div>
    </div>
  </div>
</div>

          </>
        }
      </section>
    </>
  );
};

export default Register;
